
export default function(mutation, modules) {
    const type = mutation.type.split('/');
    const moduleKey = type.length > 1 ? type[0] : '$root';
    const payload = mutation.payload;

    if(moduleKey in modules) {
        const module = modules[moduleKey];
        const moduleSettings = 'settings' in module ? module.settings : {};
        const mutation = type.length > 1 ? type[1] : type[0];

        if(!moduleSettings.persist || !moduleSettings.persist.mutations || moduleSettings.persist.mutations.includes(mutation)) {
            return {
                module: moduleKey,
                mutation: mutation,
                payload: payload
            };
        }
    }

    return false;
}